import React from 'react';
import { FormattedMessage } from 'react-intl';
import { Modal } from 'ui-components/components/modal';
import { Button } from 'ui-components/components/button';
import { ModalBody } from 'ui-components/components/modal/modal-body';
import { ModalHeader } from 'ui-components/components/modal/modal-header';
import { ModalFooter } from 'ui-components/components/modal/modal-footer';
import { emptyArray } from 'ui-components/default-props/empty';
import { RenderCustomerMarketplaceUsernames } from '../customer-information';
import messages from '../../messages';
import style from './customer-marketplace-usernames-modal.module.less';

/**
 * Modal displaying all marketplace usernames for a customer
 * @param {object} props
 * @param {Array<{marketplaceId: string, username: string}>} [props.marketplaces] - Array of marketplace username data
 * @param {object} props.modalFrameworkMethods - Modal framework methods with closeModal function
 * @returns {React.ReactElement}
 */
export const CustomerMarketplaceUsernamesModal = ({ marketplaces = emptyArray, modalFrameworkMethods }) => {
  return (
    <div className={style['marketplace-usernames-wrapper']}>
      <div className={style['marketplace-usernames-wrapper-background']} onClick={modalFrameworkMethods.closeModal} />
      <Modal className={style['marketplace-usernames-modal']}>
        <ModalHeader closeModal={modalFrameworkMethods.closeModal}>
          <FormattedMessage {...messages.marketplaceUsernamesTitle} />
        </ModalHeader>
        <ModalBody className={style['marketplace-usernames-modal-body']}>
          <RenderCustomerMarketplaceUsernames customerMarketplaces={marketplaces} />
        </ModalBody>
        <ModalFooter>
          <div className={style['marketplace-usernames-modal-footer']}>
            <Button className={style['cancel-button']} onClick={modalFrameworkMethods.closeModal} theme='tertiary'>
              <FormattedMessage {...messages.closeButton} />
            </Button>
          </div>
        </ModalFooter>
      </Modal>
    </div>
  );
};
